import { loader } from 'graphql.macro'
import { makePublicGraphQLClient } from '../../utilities/graphqlClient'

export default function publicTermsAndConditionQuery ({ queryKey }) {
  const [, token] = queryKey
  const schema = loader('./publicTermsAndCondition.graphql')
  return makePublicGraphQLClient().request(schema, { token })
}
